<template lang="pug">
  section
    RouterView
</template>

<script>
export default {
  name: "ChallengeCenterWrapper"
};
</script>

<style lang="sass" scoped></style>
